import styled, { css } from "styled-components";
export const HXTooltipContentContainer = styled.span `
    align-self: center;
    cursor: ${(props) => (props.removeMousePointer ? "default" : "pointer")};

    ${(props) => props.stretch &&
    css `
            align-self: stretch;
        `}

    ${(props) => props.align &&
    css `
            align-self: ${props.align};
        `}
`;
